import { NgModule } from '@angular/core';

import { SharedModule }                     from '../../shared/shared.module';
import { TableModule }                      from '../../table/table.module';
import { TransactionCenterOrdersComponent } from './transaction-center.orders.component';
import { TransactionCenterOrdersService }   from './transaction-center.orders.service';

@NgModule({
  declarations: [
    TransactionCenterOrdersComponent
  ],
  entryComponents: [
    TransactionCenterOrdersComponent
  ],
  imports: [
    SharedModule,
    TableModule
  ],
  providers: [
    TransactionCenterOrdersService
  ]
})
export class TransactionCenterOrdersModule {}
